import { useEffect, useState } from 'react';
import './CountDown.css';


let deadlineTime, deadline, days, hours, minutes, seconds, daysSpan, hoursSpan, minutesSpan, secondsSpan;

function updateCountdown() {
    let now = new Date().getTime();
    let timeToLive = deadline - now;
    days = Math.floor(timeToLive / (1000 * 60 * 60 * 24));
    days === 1 ? daysSpan = "DÍA" : daysSpan = "DÍAS";
    hours = Math.floor((timeToLive % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    hours === 1 ? hoursSpan = "HORA" : hoursSpan = "HORAS";
    minutes = Math.floor((timeToLive % (1000 * 60 * 60)) / (1000 * 60));
    minutes === 1 ? minutesSpan = "MINUTO" : minutesSpan = "MINUTOS";
    seconds = Math.floor((timeToLive % (1000 * 60)) / 1000);
    seconds === 1 ? secondsSpan = "SEGUNDO" : secondsSpan = "SEGUNDOS";
}

export function CountDown(eventDate) { //eventDate example -> 'Feb 6, 2027 18:30:00'
    deadlineTime = new Date(eventDate);
    deadlineTime.setDate(deadlineTime.getDate());
    deadline = deadlineTime.getTime();
    const [contador, setContador] = useState(0);
    useEffect(() => {
        const idIntervalo = setInterval(() => {
            setContador(prev => prev + 1);
            updateCountdown();
        }, 1000); // Se ejecuta cada 1000ms (1 segundo)
        return () => {
            clearInterval(idIntervalo);
        };
    }, []);

    return <div>
        <ul class="countdown-timer-ul">
            <p class="deadline-label"><span>{eventDate}</span></p>
            <div class="countainer-ul">
                <li class="date-item"><span class="days">{days}</span>{daysSpan}</li>
                <li class="date-item"><span class="hours">{hours}</span>{hoursSpan}</li>
                <li class="date-item"><span class="minutes">{minutes}</span>{minutesSpan}</li>
                <li class="date-item"><span class="seconds">{seconds}</span>{secondsSpan}</li>
            </div>
        </ul>
    </div>

}